import { theme, useTheme } from '../config/theme';

/** ============ Глобальные стили и анимации (mobile-first) ============ */
export function GlobalFX() {
  useTheme();
  return (
    <style>{`
      :root {
        --brand:${theme.brand};
        --brand-alt:${theme.brandAlt};
        --text:${theme.text};
        --muted:${theme.textSoft};
        --bg-elev:${theme.bgCard};
        --bg-soft:${theme.bgSoft};
        --border:${theme.border};
        --danger:${theme.danger};
        --background:${theme.bg};
        --surface:${theme.bgCard};
        --surface-soft:${theme.bgSoft};
        --glass-bg:${theme.glassBg};
        --glass-border:${theme.glassBorder};
        --glass-blur:${theme.glassBlur};
        /* Night Garden palette */
        --ng-midnight: #0F172A;
        --ng-warm-white: #F9FAFB;
        --ng-graphite: #475569;
        --ng-golden: #D6B370;
        --ng-sage: #A8BFAA;
        --radius-sm: 12px; --radius-md: 16px; --radius-lg: 20px; --radius-xl: 24px; --radius-full: 999px;
        --gap-1: 6px; --gap-2: 8px; --gap-3: 12px; --gap-4: 16px; --gap-5: 20px;
        --shadow-sm: 0 6px 16px rgba(2,6,23,.06);
        --shadow-md: 0 20px 48px rgba(2,6,23,.12);
        --shadow-deep: 0 30px 80px rgba(0,0,0,.32), 0 12px 32px rgba(0,0,0,.18);
        --focus: 0 0 0 3px color-mix(in srgb, var(--brand) 25%, transparent);
      }
      * { box-sizing: border-box; }
      html, body, #root { height: 100%; }

      .bg-anim {
        position: fixed; inset: -40vmax; z-index: -1; filter: blur(72px); opacity: .40;
        background: conic-gradient(from 180deg at 50% 50%, rgba(79,70,229,.9), rgba(34,211,238,.65), rgba(99,102,241,.85), rgba(79,70,229,.9));
        animation: orbit 60s linear infinite;
      }
      @keyframes orbit { to { transform: rotate(360deg); } }

      .fade-in { animation: fade .5s ease both; }
      @keyframes fade { from { opacity:0; transform: translateY(6px) scale(.98); } to { opacity:1; transform: none; } }

      /* Subtle breathing for living UI */
      .breath { animation: breath 8s ease-in-out infinite; }
      @keyframes breath {
        0%, 100% { transform: translateY(0) scale(1); opacity: 1; }
        50% { transform: translateY(-1px) scale(1.005); opacity: .985; }
      }

      .card { overflow: hidden; }

      /* Lucide icons: uniform outline look */
      .lucide { stroke-width: 1.75; stroke-linecap: round; stroke-linejoin: round; }

      /* Calendar pickers visibility in dark mode */
      input[type="date"], input[type="datetime-local"] { color-scheme: ${theme.mode === 'dark' ? 'dark' : 'light'}; }
      input[type="date"]::-webkit-calendar-picker-indicator,
      input[type="datetime-local"]::-webkit-calendar-picker-indicator {
        filter: ${theme.mode === 'dark' ? 'invert(1) brightness(2.6) contrast(1.3)' : 'none'};
        opacity: ${theme.mode === 'dark' ? '0.95' : '1'};
      }
      /* Ensure checkboxes/radios follow site theme, not browser theme */
      input[type="checkbox"], input[type="radio"] {
        color-scheme: ${theme.mode === 'dark' ? 'dark' : 'light'};
        accent-color: ${theme.brand};
      }

      /* Accessible focus ring */
      :where(a, button, [role="button"], input, select):focus-visible {
        outline: 0;
        box-shadow: var(--focus);
      }

      /* Keyboard-only ring for textareas via data attribute */
      textarea[data-keyfocus="1"]:focus {
        outline: 0;
        box-shadow: var(--focus);
      }

      /* Reduced motion support */
      @media (prefers-reduced-motion: reduce) {
        *, *::before, *::after {
          animation-duration: 0.01ms !important;
          animation-iteration-count: 1 !important;
          transition-duration: 0.01ms !important;
          scroll-behavior: auto !important;
        }
      }
    `}</style>
  );
}
